

import Vue from "vue";
import App from "./App";
import router from "./router";
import layer from "vue-layer";
import Moment from "moment";
import store from "./store";
import LoadingPlugin from 'vux/src/plugins/loading/index.js'



import "element-ui/lib/theme-chalk/display.css";
import "@/config/decimal";
import {
Row,
Col,
Menu,
Submenu,
MenuItem,
Form,
FormItem,
Input,
InputNumber,
Pagination,
Select,
Option,
Radio,
RadioGroup,
Button,
Table,
TableColumn,
Container,
Header,
Aside,
Main,
Dialog,
Footer,
Message,
MessageBox,
DatePicker,
Autocomplete,
divider,
image,
Checkbox,
Collapse,
CollapseItem
} from "element-ui";


Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Checkbox);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(DatePicker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Autocomplete);
Vue.use(divider);
Vue.use(image);

let browser = navigator.userAgent.toLowerCase();

Vue.config.productionTip = false;

Vue.use(LoadingPlugin);

Vue.prototype.$message = Message;

Vue.prototype.$msgbox = MessageBox;

Vue.prototype.$layer = layer(Vue);

Vue.prototype.$isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
navigator.userAgent
);

Vue.prototype.$isZfb = browser.match(/Alipay/i) == "alipay";

Vue.prototype.$isWx = browser.match(/MicroMessenger/i) == "micromessenger";

Vue.prototype.$moment = Moment;

/* eslint-disable no-new */
new Vue({
el: "#app",
router,
store,
components: { App },
template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js